var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDollerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trailing-icon",
    clipPath: "url(#dollerIcon)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.3 11.0222C10.03 10.4978 9.3 9.95556 9.3 9.11111C9.3 8.14222 10.31 7.46667 12 7.46667C13.42 7.46667 14.13 7.94667 14.39 8.71111C14.51 9.06667 14.84 9.33333 15.26 9.33333H15.56C16.22 9.33333 16.69 8.75556 16.46 8.20444C16.04 7.15556 15.06 6.28444 13.5 5.94667V5.33333C13.5 4.59556 12.83 4 12 4C11.17 4 10.5 4.59556 10.5 5.33333V5.92C8.56 6.29333 7 7.41333 7 9.12889C7 11.1822 8.91 12.2044 11.7 12.8C14.2 13.3333 14.7 14.1156 14.7 14.9422C14.7 15.5556 14.21 16.5333 12 16.5333C10.35 16.5333 9.5 16.0089 9.17 15.2622C9.02 14.9156 8.68 14.6667 8.27 14.6667H7.99C7.32 14.6667 6.85 15.2711 7.1 15.8222C7.67 17.0578 9 17.7867 10.5 18.0711V18.6667C10.5 19.4044 11.17 20 12 20C12.83 20 13.5 19.4044 13.5 18.6667V18.0889C15.45 17.76 17 16.7556 17 14.9333C17 12.4089 14.57 11.5467 12.3 11.0222Z",
    fill: "#295BB7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "dollerIcon"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollerIcon);
export default __webpack_public_path__ + "static/media/dollerIcon.15271327fdeaa53f3f099d2c3970d690.svg";
export { ForwardRef as ReactComponent };